module.exports = "/images/search.svg?b589ae9a8222a4c18d44c4617ee42dd6";